import { BasketData } from '../basket-data';
import { BasketSettings } from '../basket-settings/basket-settings';
import { BasketStorage } from '../basket-storage/basket-storage';
import { ShadowStorage } from '../shadow-storage/shadow-storage';
export class ShadowSetup {
    static init(siteContextResolverService, hrefResolver, contentService, basketDataTransformer) {
        let shadowStorage;
        let shadowBasketStorage;
        if (siteContextResolverService.getMappedContext().includes('ch')) {
            const shadowBasketData = new BasketData(hrefResolver, contentService);
            const shadowBasketSettings = new BasketSettings();
            shadowBasketStorage = new BasketStorage(window, shadowBasketSettings, siteContextResolverService);
            shadowStorage = new ShadowStorage(shadowBasketData, basketDataTransformer, shadowBasketStorage, contentService);
        }
        return { shadowStorage };
    }
}
